export default __webpack_public_path__ + "static/media/google.06a198a9.svg";